import { Popover, Checkbox, Button } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import trans from "../../../utils";

// "Columns" show/hide control for the Dispatcher table. Renders a checkbox
// list of the toggleable columns inside a popover; visibility is owned by
// the parent (Dispatcher.jsx) so it can be persisted across sessions.
export default function ColumnsToggle({ columns, visibleKeys, onChange }) {
  const toggle = (key) => {
    const next = visibleKeys.includes(key)
      ? visibleKeys.filter((k) => k !== key)
      : [...visibleKeys, key];
    onChange(next);
  };

  const content = (
    <div className="d-flex flex-column gap-2" style={{ minWidth: 200 }}>
      {columns.map((col) => (
        <Checkbox key={col.key} checked={visibleKeys.includes(col.key)} onChange={() => toggle(col.key)}>
          {col.title}
        </Checkbox>
      ))}
    </div>
  );

  return (
    <Popover title={trans("Columns")} content={content} trigger="click" placement="bottomRight">
      <Button icon={<SettingOutlined />}>{trans("Columns")}</Button>
    </Popover>
  );
}
